module.exports = __webpack_public_path__ + "static/23-9a30450cf47ead47e282289824cf2517.png";